<template>
  <div>
    <h3>{{$t('messages.confirm_remove.title')}}</h3>
    <p>{{$t('messages.confirm_remove.message', { name: groupName })}}</p>
    <div class="form">
      <div class="form-footer">
        <button type="submit" class="btn btn-default btn-sm" @click="onCancel">
          {{ $t("form.button.cancel")}}
        </button>
        <button type="submit" class="btn btn-carma btn-sm" @click="onSubmit">
          {{ $t("form.button.remove")}}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    group: Object
  },

  computed: {
    groupName () {
      return this.group && this.group.name || '';
    }
  },

  methods: {
    onSubmit () {
      this.$emit('remove');
    },

    onCancel () {
      this.$emit('cancel');
    }
  }
}
</script>